import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled';
import { useIsMobile } from "~helpers/hooks/useIsMobile";
import { AmplitudeCounter } from "~/amplitude-counter";

const MobileAppScreen = () => {
  const isMobile = useIsMobile();

  return (
    <Screen
      bottomLine={true}
    >
      <Styled.Container>
        <Styled.Col>
          <Styled.Title><StyledScreen.GreenText>Лучшее</StyledScreen.GreenText> мобильное приложение в своем сегменте</Styled.Title>
          {
            isMobile &&
            <Styled.Icon>
              <Styled.IconImage><img src={process.env.PUBLIC_DIR + '/images/mobile-phone-img.png'} alt='mobile'/></Styled.IconImage>
              <Styled.IconImageRating><img src={process.env.PUBLIC_DIR + '/images/mobile-rating.svg'} /></Styled.IconImageRating>
            </Styled.Icon>
          }
          <Styled.Text>Высшая оценка приложения onlinepbx в AppStore среди аналогов.</Styled.Text>
          <Styled.Badges>
            <Styled.Badge>
              <a
                href='https://apps.apple.com/ru/app/onlinepbx/id1444397107'
                target='_blank'
                onClick={() => AmplitudeCounter('click_download_mobile', { service: 'AppStore' })}
              >
                <img src={process.env.PUBLIC_DIR + '/images/app-store-badge.svg'} />
              </a>
            </Styled.Badge>
            <Styled.Badge>
              <a
                href='https://play.google.com/store/apps/details?id=com.onlinepbx&hl=ru'
                target='_blank'
                onClick={() => AmplitudeCounter('click_download_mobile', { service: 'GooglePlay' })}
              >
                <img src={process.env.PUBLIC_DIR + '/images/google-play-badge.svg'} />
              </a>
            </Styled.Badge>
          </Styled.Badges>
        </Styled.Col>
        {
          !isMobile &&
          <Styled.Col>
            <Styled.Icon>
              <Styled.IconImage><img src={process.env.PUBLIC_DIR + '/images/mobile-phone-img.svg'} alt='mobile'/></Styled.IconImage>
              <Styled.IconImageRating><img src={process.env.PUBLIC_DIR + '/images/mobile-rating.svg'} /></Styled.IconImageRating>
            </Styled.Icon>
          </Styled.Col>
        }
      </Styled.Container>
    </Screen>
  )
}

export { MobileAppScreen }